import { Component, OnInit } from '@angular/core';
import { AppRoutes, GeneralService } from '@gs-2.0/core';

@Component({
  selector: 'app-footer',
  standalone: false,
  templateUrl: './footer.component.html',
  styleUrl: './footer.component.scss',
})
export class FooterComponent implements OnInit {
  readonly AppRoutes = AppRoutes;

  footerBackgroundColor = '';
  logoUrl = '';
  newsLink = '';
  termsOfUseLink = '';
  privacyPolicyLink = '';
  companyName = '';
  parentWebsiteLink = '';

  constructor(private generalService: GeneralService) {}

  ngOnInit(): void {
    this.footerBackgroundColor = this.resolveFooterColor();
    this.logoUrl = this.resolveLogoUrl();
    this.newsLink = this.resolveConfigString('newsLink');
    this.termsOfUseLink = this.resolveConfigString('termsOfUse');
    this.privacyPolicyLink = this.resolveConfigString('privacyPolicy');
    this.companyName = this.resolveConfigValue('companyName');
    this.parentWebsiteLink = this.resolveConfigString('footerParentWebsiteLink');
  }

  private resolveConfigValue(key: string): string {
    const settings = this.generalService.settings;
    if (!settings) return '';
    const item = settings.response.globalConfig.find((c) => c.key === key);
    return item?.value || '';
  }

  private resolveConfigString(key: string): string {
    const value = this.resolveConfigValue(key);
    if (!value) return '';
    return /^https?:\/\//i.test(value) ? value : `https://${value}`;
  }

  private resolveLogoUrl(): string {
    const settings = this.generalService.settings;
    if (!settings) return '';
    const item = settings.response.globalConfig.find((c) => c.key === 'whiteLogo');
    if (!item) return '';
    try {
      const parsed = JSON.parse(item.value);
      return parsed?.url || '';
    } catch {
      return '';
    }
  }

  private resolveFooterColor(): string {
    const settings = this.generalService.settings;
    if (!settings) return '';
    const item = settings.response.globalConfig.find((c) => c.key === 'footerColor');
    if (!item) return '';
    try {
      const parsed = JSON.parse(item.value);
      return parsed?.hex ? `#${parsed.hex}` : '';
    } catch {
      return '';
    }
  }
}
